import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'ppl-view-recon-files',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './view-workday-status.component.html',
  styleUrl: './view-workday-status.component.css'
})
export class ViewWorkdayStatusComponent {

}
